class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.load-more-pagination__button');
    if (!this.button) return;
    this.spinner = this.button.querySelector('.loading__spinner');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.button.getAttribute('aria-disabled') === 'true') return;

    const nextUrl = this.button.getAttribute('data-next-url');
    if (!nextUrl) return;

    this.setLoading(true);

    const sectionId = this.dataset.sectionId;
    const separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    const url = `${nextUrl}${separator}section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.appendProducts(html);
        this.updateControl(html);
        // Note: the URL is intentionally left unchanged. Loaded products only exist in the
        // current DOM, so pointing the address bar at a later page would make a reload
        // render just that page's slice instead of everything the customer has loaded.
      })
      .catch(() => {
        this.setLoading(false);
      });
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.button.setAttribute('aria-disabled', 'true');
    } else {
      this.button.removeAttribute('aria-disabled');
    }
    if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
  }

  appendProducts(html) {
    const sourceGrid = html.getElementById('product-grid');
    const targetGrid = document.getElementById('product-grid');
    if (!sourceGrid || !targetGrid) return;

    Array.from(sourceGrid.children).forEach((item) => {
      item.classList.remove('scroll-trigger', 'animate--slide-in');
      item.removeAttribute('data-cascade');
      item.removeAttribute('style');
      targetGrid.appendChild(item);
    });
  }

  updateControl(html) {
    const newControl = html.querySelector('load-more-products');
    if (newControl) {
      this.replaceWith(newControl);
    } else {
      this.remove();
    }
  }
}

if (!customElements.get('load-more-products')) {
  customElements.define('load-more-products', LoadMoreProducts);
}
